/*--------------------- Copyright (c) 2018 -----------------------
[Master Javascript]
Project: Miraculous - Online Music Store Html Template
Version: 1.0.0
Assigned to: Theme Forest
-------------------------------------------------------------------*/

(function($) {
    "use strict";
    var music = {
        initialised: false,
        version: 1.0,
        mobile: false,
        init: function() {
            if (!this.initialised) {
                this.initialised = true;
            } else {
                return;
            }
            /*-------------- Music Functions Calling ---------------------------------------------------
            ------------------------------------------------------------------------------------------------*/
            this.RTL();
            this.Popup();
            this.More();
            this.Nice_select();
            this.showPlayList();
            this.volume();
            this.ReplyComment();
            this.Notification();
        },
        /*-------------- Music Functions definition ---------------------------------------------------
        ---------------------------------------------------------------------------------------------------*/
        RTL: function() {
            var rtl_attr = $("html").attr('dir');
            if (rtl_attr) {
                $('html').find('body').addClass("rtl");
            }
        },
        // Pop Up
        Popup: function() {
            $('.clr_modal_btn a').on('click', function() {
                $('#clear_modal').hide();
                $('.modal-backdrop').hide();
                $('body').removeClass("modal-open").css("padding-right", "0px");
            })
            $('.hideCurrentModel').on('click', function() {
                $(this).closest('.modal-content').find('.form_close').trigger('click');
            });
            // Language Popup
            $('.lang_list').find("input[type=checkbox]").on('change', function() {
                if ($('.lang_list').find("input[type=checkbox]:checked").length) {
                    $('.ms_lang_popup .modal-content').addClass('add_lang');
                } else {
                    $('.ms_lang_popup .modal-content').removeClass('add_lang');
                }
            });
        },

        // More
        More: function() {
            $(document).on('click', '.ms_more_icon', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (typeof $(this).attr('data-other') != 'undefined') {
                    var target = $(this).parent().parent();
                } else if($(this).attr('data-toggle') == 'popup'){
                    var target = $(this).parent().parent().parent();
                }
                else {
                    var target = $(this).parent();
                }
                if (target.find("ul.more_option").hasClass('open_option')) {
                    target.find("ul.more_option").removeClass('open_option');
                } else {
                    $("ul.more_option.open_option").removeClass('open_option');
                    target.find("ul.more_option").addClass('open_option');
                }
            });

            $(document).on("click", function(e) {
                $("ul.more_option.open_option").removeClass("open_option");
            });

        },

        // Reply Comment
        ReplyComment: function() {
            $(document).on('click', '.reply_comment', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var target = $(this).parent();
                var parent_id=target.find("#parent-comment").data("id");
                document.cookie = "comment_parent_id=" + parent_id;
                // target.find("#parent-comment").val(parent_id);
                if (target.find(".reply-box").hasClass('open_box')) {
                    target.find(".reply-box").removeClass('open_box');
                } else {
                    $(".reply-box.open_box").removeClass('open_box');
                    target.find(".reply-box").addClass('open_box');
                }
            });

            // $(document).on("click", function(e) {
            //     $(".reply-box.open_box").removeClass("open_box");
            // });

        },
        Notification: function(){
            $(document).on('click', '#notification', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if($('.custom-popper').hasClass('open-popper'))
                {
                    $('.custom-popper.open-popper').removeClass('open-popper');
                }else{
                    $('.custom-popper').addClass('open-popper');
                }
            });

            $("body").on("click", function(e) {
                // console.log($(e.target).attr('class'));
                // $('.custom-popper.open-popper').removeClass('open-popper');
            });
        },

        // Nice Select
        Nice_select: function() {
            if ($('.custom_select').length > 0) {
                $('.custom_select select').niceSelect();
            }
        },
        showPlayList: function() {
            $(document).on('click', '#myPlaylistQueue', function() {
                $('#playlist-wrap').fadeToggle();
            });
            $('#playlist-wrap').on('click', '#myPlaylistQueue', function(event) {
                event.stopPropagation();
            });
        },

        // Volume
        volume: function() {
            $(".knob-mask .knob").css("transform", "rotateZ(270deg)");
            $(".knob-mask .handle").css("transform", "rotateZ(270deg)");
        }

    };
    $(document).ready(function() {
        music.init();

    });

    // Window Scroll
    $(window).scroll(function() {
        var wh = window.innerWidth;
        //Go to top
        if ($(this).scrollTop() > 100) {
            $('.gotop').addClass('goto');
        } else {
            $('.gotop').removeClass('goto');
        }
    });
    $(".gotop").on("click", function() {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false
    });


})(jQuery);

if (navigator.userAgent.match(/android/i)) {
    document.getElementById('play-store-link').href = 'market://details?id=com.melomm.mmusicnet';
}
